export type AppColor = 'red' | 'orange' | 'green' | 'blue' | 'purple'

export interface SharedAppEntry {
  appKey: string
  title: string
  description: string
  icon: string
  color: AppColor
  tenantFeatures: string[]
  capabilities?: string[]
}

export const SHARED_APP_ENTRIES: SharedAppEntry[] = [
  {
    appKey: 'kt',
    title: '课堂教学中心',
    description: '打开 PC 独立应用，使用班级、作业、课堂互动与成绩看板。',
    icon: 'Folder',
    color: 'green',
    tenantFeatures: ['teacher.kt.assignments', 'teacher.kt.lessons', 'student.kt.assignments', 'student.kt.assignments.submit'],
    capabilities: ['kt.lessons.teach', 'kt.lessons.learn'],
  },
  {
    appKey: 'jy',
    title: '教学方案协作中心',
    description: '打开 PC 独立应用，使用教研文档、结构化备课与课堂控制台。',
    icon: 'Document',
    color: 'blue',
    tenantFeatures: ['teacher.jy.docs', 'student.jy.docs', 'student.jy.docs.view'],
    capabilities: ['jy.documents.view', 'jy.documents.manage', 'jy.documents.review'],
  },
  {
    appKey: 'match',
    title: '赛事管理中心',
    description: '打开 PC 独立应用，使用赛事、报名、项目评审与实时看板。',
    icon: 'Trophy',
    color: 'orange',
    tenantFeatures: ['teacher.match.realtime', 'teacher.match.projects', 'teacher.match.participate', 'teacher.match.reviews', 'student.match.info', 'student.match.signup', 'external.match.participate'],
    capabilities: ['match.participate', 'match.review', 'match.manage', 'teacher.match.participate', 'student.match.participate', 'external.match.participate', 'teacher.match.review'],
  },
  {
    appKey: 'ai-learning',
    title: '智学成长',
    description: '打开 PC 独立应用，使用 AI 辅助学习、智能对话与学习画像。',
    icon: 'ControlPlatform',
    color: 'purple',
    tenantFeatures: ['student.ai-learning', 'teacher.ai-learning'],
    capabilities: ['student.ai-learning.profile', 'teacher.ai-learning.workbench'],
  },
]

export const INDEPENDENT_APP_KEYS = SHARED_APP_ENTRIES.map((entry) => entry.appKey)
export const INDEPENDENT_APP_KEY_SET = new Set(INDEPENDENT_APP_KEYS)

const appKeyPattern = /^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/

function normalizeSharedAppKey(appKey: string): string {
  const normalizedAppKey = appKey.trim()
  if (!appKeyPattern.test(normalizedAppKey)) {
    throw new Error(`非法应用 key: ${appKey}`)
  }
  return normalizedAppKey
}

export function isIndependentAppKey(appKey: string): boolean {
  return INDEPENDENT_APP_KEY_SET.has(normalizeSharedAppKey(appKey))
}

export function resolveSharedAppEntry(appKey: string): SharedAppEntry {
  const normalized = normalizeSharedAppKey(appKey)
  const entry = SHARED_APP_ENTRIES.find((item) => item.appKey === normalized)
  if (!entry) {
    throw new Error(`未登记独立应用: ${normalized}`)
  }
  return entry
}
